import { MasterDataTable } from "@/components/MasterDataTable";
import { useAdminProjectCodes, useProjectCodeAdmin } from "@/hooks/useMasterData";

const ProjectCodes = () => {
  const { data: projectCodes = [], isLoading } = useAdminProjectCodes();
  const admin = useProjectCodeAdmin();

  return (
    <MasterDataTable
      items={projectCodes.map((i) => ({ id: i.id, label: i.code, is_active: i.is_active }))}
      valueLabel="Code"
      isLoading={isLoading}
      onCreate={(code) => admin.create.mutateAsync(code)}
      onUpdate={(id, data) => admin.update.mutateAsync({ id, data })}
      onDelete={(id) => admin.remove.mutateAsync(id)}
    />
  );
};

export default ProjectCodes;
